
import React from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import { FlaskConical, Globe, Wrench, Map } from 'lucide-react';
import TechLogoBanner from './TechLogoBanner';

const AboutSection = () => {
  const { t } = useLanguage();

  return (
    <section className="py-24 relative" id="about">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-white">
        <div className="absolute inset-0 opacity-5" style={{ 
          backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'20\' height=\'20\' viewBox=\'0 0 20 20\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'%23EF3E2C\' fill-opacity=\'0.4\' fill-rule=\'evenodd\'%3E%3Ccircle cx=\'3\' cy=\'3\' r=\'3\'/%3E%3Ccircle cx=\'13\' cy=\'13\' r=\'3\'/%3E%3C/g%3E%3C/svg%3E")',
        }}></div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-1/4 right-0 w-72 h-72 bg-attaboy/5 rounded-full filter blur-3xl -z-10"></div>
      <div className="absolute bottom-1/4 left-0 w-72 h-72 bg-attaboy-light/5 rounded-full filter blur-3xl -z-10"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 font-poppins text-center">{t('about.title')}</h2>
          
          <div className="flex justify-center mb-12">
            <div className="relative">
              <div className="h-32 w-32 relative z-10">
                <svg
                  className="h-full w-full text-attaboy"
                  viewBox="0 0 500 500"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M250 80 L80 400 L420 400 Z" />
                  <circle cx="380" cy="160" r="80" />
                </svg>
              </div>
              <div className="absolute -inset-4 bg-attaboy-faded rounded-full filter blur-xl z-0"></div>
            </div>
          </div>
          
          <h3 className="text-2xl md:text-3xl font-bold mb-6 font-poppins text-center text-attaboy">
            {t('about.mission')}
          </h3>
          
          <div className="text-lg text-gray-600 mb-10 text-center leading-relaxed space-y-4">
            <p>{t('about.paragraph1')}</p>
            
            <p>{t('about.paragraph2')}</p>
            
            <p>{t('about.paragraph3')}</p>
            
            <p className="font-medium pt-4">{t('about.what_sets_us_apart')}</p>
            
            <ul className="text-left max-w-lg mx-auto space-y-4">
              <li className="flex items-start">
                <div className="mr-3 mt-0.5 bg-attaboy/10 p-2 rounded-md">
                  <FlaskConical size={20} className="text-attaboy" />
                </div>
                <span>{t('about.feature1')}</span>
              </li>
              <li className="flex items-start">
                <div className="mr-3 mt-0.5 bg-attaboy/10 p-2 rounded-md">
                  <Globe size={20} className="text-attaboy" />
                </div>
                <span>{t('about.feature2')}</span>
              </li>
              <li className="flex items-start">
                <div className="mr-3 mt-0.5 bg-attaboy/10 p-2 rounded-md">
                  <Wrench size={20} className="text-attaboy" />
                </div>
                <span>{t('about.feature3')}</span>
              </li>
              <li className="flex items-start">
                <div className="mr-3 mt-0.5 bg-attaboy/10 p-2 rounded-md">
                  <Map size={20} className="text-attaboy" />
                </div>
                <span>{t('about.feature4')}</span>
              </li>
            </ul>
            
            <p className="pt-4">{t('about.paragraph4')}</p>
            
            <p className="font-medium">{t('about.paragraph5')}</p>
          </div>
          
          <div className="flex justify-center items-center mb-8">
            <div className="bg-attaboy/5 py-3 px-6 rounded-full flex items-center space-x-2">
              <svg className="h-5 w-5 text-attaboy" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM4.332 8.027a6.012 6.012 0 011.912-2.706C6.512 5.73 6.974 6 7.5 6A1.5 1.5 0 019 7.5V8a2 2 0 004 0 2 2 0 011.523-1.943A5.977 5.977 0 0116 10c0 .34-.028.675-.083 1H15a2 2 0 00-2 2v2.197A5.973 5.973 0 0110 16v-2a2 2 0 00-2-2 2 2 0 01-2-2 2 2 0 00-1.668-1.973z" clipRule="evenodd" />
              </svg>
              <span className="font-medium text-attaboy">{t('about.canadian')}</span>
            </div>
          </div>
          
          {/* Tech Logo Banner */}
          <TechLogoBanner />
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
